import UmmIAPlanCardImg from "../components/Home/img/UmmIAPlanCardImg.png";
import UmmIAClaseCardImg from "../components/Home/img/UmmIAClaseCardImg.png";
import UmmIAEvCardImg from "../components/Home/img/UmmIAEvCardImg.png";
import UmmIAComCardImg from "../components/Home/img/UmmIAComCardImg.png";
import UmmIAPediaCardImg from "../components/Home/img/UmmIAPediaCardImg.png";
import UmmIAHogarCardImg from "../components/Home/img/UmmIAHogarCardImg.png";
import UmmIAppsFavoritasCardImg from "../components/Home/img/UmmIAppsFavoritasCardImg.png";
import { iDataComponentes } from "../interfaces/SuperAdmin/Others/iDataComponentes";
import UmmIAPlanPage from "../pages/Categories/UmmIAPlanPage";
import UmmIAClasePage from "../pages/Categories/UmmIAClasePage";
import UmmIAEvPage from "../pages/Categories/UmmIAEvPage";
import UmmIAComPage from "../pages/Categories/UmmIAComPage";
import UmmIAPediaPage from "../pages/Categories/UmmIAPediaPage";
import { Icons } from "../layout/Drawer/Sidebar/Icons";
import { LiteralCategoria } from "../types/LiteralCategoria";
import UmmIAARGPage from "../pages/Categories/UmmIAARGPage";

export interface iCategoria {
  label: LiteralCategoria;
  descripcion: string;
  img: string;
  alt: string;
  route: string;
  backgroundColor: string;
  borderColor: string;
  elemento: JSX.Element;
  icon: () => JSX.Element;
}

export const categorias: iCategoria[] = [
  {
    label: "UmmIAPlan",
    descripcion: "Tu planificador de clases inteligente y creativo",
    img: UmmIAPlanCardImg,
    alt: "Imagen UmmIA Plan",
    route: "ummiaplan",
    backgroundColor: "#F6FAF9",
    borderColor: "#278C62",
    elemento: <UmmIAPlanPage />,
    icon: Icons.PersonPlay,
  },
  {
    label: "UmmIAClase",
    descripcion: "Aplicaciones para enriquecer tu trabajo en el aula",
    img: UmmIAClaseCardImg,
    alt: "Imagen UmmIA Clase",
    route: "ummiaclase",
    backgroundColor: "#FCF7F8",
    borderColor: "#BA4534",
    elemento: <UmmIAClasePage />,
    icon: Icons.UmmIAClase,
  },
  {
    label: "UmmIAEv",
    descripcion: "Aplicaciones para evaluar y retroalimentar el aprendizaje",
    img: UmmIAEvCardImg,
    alt: "Imagen UmmIA Ev",
    route: "ummiaev",
    backgroundColor: "#FEFDF5",
    borderColor: "#EDD205",
    elemento: <UmmIAEvPage />,
    icon: Icons.UmmIAEv,
  },
  {
    label: "UmmIACom",
    descripcion: "Aplicaciones para apoyar tu gestión y comunicaciones",
    img: UmmIAComCardImg,
    alt: "Imagen UmmIA Com",
    route: "ummiacom",
    backgroundColor: "#F9FBFC",
    borderColor: "#6A93A8",
    elemento: <UmmIAComPage />,
    icon: Icons.UmmIACom,
  },
  {
    label: "UmmIAHogar",
    descripcion:
      "Aplicaciones y juegos lúdicos para niños que ayudan a fortalecer su aprendizaje.",
    img: UmmIAHogarCardImg,
    alt: "Imagen UmmIA Hogar",
    route: "ummiahogar",
    backgroundColor: "#F8FDFE",
    borderColor: "#45C3EE",
    elemento: <UmmIAARGPage />,
    icon: Icons.Family,
  },
  {
    label: "UmmIAPedia",
    descripcion: "Aplicaciones para fortalecer tu desarrollo profesional",
    img: UmmIAPediaCardImg,
    alt: "Imagen UmmIA Pedia",
    route: "ummiapedia",
    backgroundColor: "#FAF7F8",
    borderColor: "#8B3355",
    elemento: <UmmIAPediaPage />,
    icon: Icons.Chat,
  },
  {
    label: "UmmIApps Favoritas",
    descripcion: "Las aplicaciones que más usas y has seleccionado",
    img: UmmIAppsFavoritasCardImg,
    alt: "Imagen UmmIA Apps favoritas",
    route: "menu",
    backgroundColor: "#FEF9F9",
    borderColor: "#E57373",
    elemento: <UmmIAPlanPage />,
    icon: Icons.Chat,
  },
];

export const getCategories = (apps: iDataComponentes[]): iCategoria[] => {
  const cats = new Set(apps.map((app) => app.categoria));
  return categorias.filter((cat) => cats.has(cat.label));
};
